import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Fraunces, Geist, Geist_Mono } from 'next/font/google'

const geistSans = Geist({
    variable: '--font-sans',
    subsets: ['latin']
})

const geistMono = Geist_Mono({
    variable: '--font-geist-mono',
    subsets: ['latin']
})

const fraunces = Fraunces({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    axes: ['opsz', 'SOFT', 'WONK'],
    display: 'swap',
    variable: '--font-fraunces'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${geistSans.variable} ${geistMono.variable} ${fraunces.variable} h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App